module.exports = __webpack_public_path__ + "static/media/no-data.ff3f5f85.svg";